/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className='text-center my-5'>
      <h1>404 - Page Not Found 🧐</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" style={{color: 'red'}}>Go back Home</Link>
    </div>
  );
};

export default NotFound;
